import styled from "@emotion/styled"
import { keyframes } from "@emotion/react"

import { Icon } from "components/icon/Icon"

const loaderAnim = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`
const Root = styled.div`
  width: 60px;
  height: 60px;
  display: grid;
  grid-template: "loader";
  place-items: center;
  margin-inline: auto;

  &:before {
    grid-area: loader;
    content: "";
    display: block;
    width: inherit;
    height: inherit;
    border-radius: 50%;
    background: linear-gradient(rgb(var(--light-black)), #fff);
    animation-name: ${loaderAnim};
    animation-duration: 1.2s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    z-index: 1;
    -webkit-mask: radial-gradient(transparent 28px, #000 28px);
    mask: radial-gradient(transparent 28px, #000 28px);
  }

  svg {
    grid-area: loader;
    z-index: 2;
    width: 40%;
    height: 40%;
    fill: rgb(var(--rolex-gold));
  }
`

export default function Loader() {
  return (
    <Root className='loader'>
      <Icon type='crown' />
    </Root>
  )
}
